import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export const ScaffoldSection = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ children, className, ...props }, ref) => (
  <div
    className={cn(
      "relative flex flex-col gap-12 overflow-hidden py-12",
      className
    )}
    ref={ref}
    {...props}
  >
    {children}
  </div>
));

ScaffoldSection.displayName = "ScaffoldSection";

export const ScaffoldSectionContainer = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ children, className, ...props }, ref) => (
  <div
    className={cn(
      "container mx-auto flex w-full flex-col gap-6 px-4",
      className
    )}
    ref={ref}
    {...props}
  >
    {children}
  </div>
));

ScaffoldSectionContainer.displayName = "ScaffoldSectionContainer";

export const ScaffoldSectionContent = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ children, className, ...props }, ref) => (
  <div
    className={cn("flex flex-col items-center gap-6", className)}
    ref={ref}
    {...props}
  >
    {children}
  </div>
));

ScaffoldSectionContent.displayName = "ScaffoldSectionContent";

export const ScaffoldSectionHeader = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ children, className, ...props }, ref) => (
  <div className={cn("flex flex-col gap-2", className)} ref={ref} {...props}>
    {children}
  </div>
));

ScaffoldSectionHeader.displayName = "ScaffoldSectionHeader";

export const ScaffoldSectionTitle = forwardRef<
  HTMLHeadingElement,
  HTMLAttributes<HTMLHeadingElement>
>(({ children, className, ...props }, ref) => (
  <h2
    className={cn(
      "text-balance text-center font-bold text-4xl uppercase leading-trim hyphens-auto break-words",
      className
    )}
    ref={ref}
    {...props}
  >
    {children}
  </h2>
));

ScaffoldSectionTitle.displayName = "ScaffoldSectionTitle";

export const ScaffoldSectionDescription = forwardRef<
  HTMLParagraphElement,
  HTMLAttributes<HTMLParagraphElement>
>(({ children, className, ...props }, ref) => (
  <p
    className={cn(
      "mx-auto mt-4 max-w-prose text-balance text-center text-lg",
      className
    )}
    ref={ref}
    {...props}
  >
    {children}
  </p>
));

ScaffoldSectionDescription.displayName = "ScaffoldSectionDescription";
